import React, { ReactNode } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

// These values mirror the layout of `PressableItemCard`
// (`components/quests/components/pressable-item-card.tsx`):
// the outer `Pressable` uses `padding="$2"` and the image `Box` uses `w="$20"`.
// Keep these in sync if that card's layout changes.
const IMAGE_BOX_WIDTH = spacing.$20;
const CARD_PADDING = spacing.$2;

interface ILockedPreviewProps {
  children: ReactNode;
}

export const LockedPreview = ({ children }: ILockedPreviewProps) => (
  <Box style={styles.wrapper}>
    {children}
    <Box style={styles.overlay} pointerEvents="none">
      <Icon variant="locked" size="8" color={primitive.$bbqBrown} />
    </Box>
  </Box>
);

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    top: CARD_PADDING,
    bottom: CARD_PADDING,
    left: CARD_PADDING,
    width: IMAGE_BOX_WIDTH,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
